// Shared helpers for Google Analytics (gtag) enhanced conversions. public/index.html
// loads gtag and the Meta Pixel on production hosts only; callers still guard on
// typeof window.gtag === 'function' because the scripts may be blocked.
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void;
  }
}

// This app collects mobile numbers as plain 10-digit values (country code is a
// separate UI field), so they are never already E.164 and need '+91' prepended.
export function toE164(raw?: string | number | null): string | undefined {
  const digits = raw ? String(raw).replace(/\D/g, '') : '';
  if (!digits) return undefined;
  return digits.startsWith('91') && digits.length > 10
    ? `+${digits}`
    : `+91${digits}`;
}

// Enhanced conversions need raw (unhashed) email/phone set via
// gtag('set', 'user_data', ...) immediately before the event tag.
export function setGtagUserData(user: {
  email?: string;
  phone?: string;
}): void {
  if (typeof window.gtag !== 'function') return;
  const userData: Record<string, string> = {};
  if (user.email) userData.email = user.email;
  if (user.phone) userData.phone_number = user.phone;
  if (Object.keys(userData).length > 0) {
    window.gtag('set', 'user_data', userData);
  }
}
